define("shared/components/shared/credentials/password-input", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _tracking, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--formWrapper--lg u--relative">
    <label for={{@id}}>{{this.passwordLabel}}</label>
    <div class="u--relative">
      <Input
        @type={{this.passwordInputType}}
        @value={{@password}}
        autocomplete="new-password"
        class={{concat "tSU--card__input form-control o--form__input dd-privacy-mask-user-input qa--" @qaClassName}}
        data-test-id={{@dataTestID}}
        id={{@id}}
        placeholder={{t "authorization.create_account.placeholder_password"}}
      />
  
      {{#if this.showPasswordInput}}
        <button
          class="o--btn--lg tSU--card__inputButton"
          tabindex="-1"
          type="button"
          {{on "click" this.togglePasswordVisibility}}
        >
          {{svg-jar "view" class="o--icon--md tSU--card__inputIcon"}}
        </button>
      {{else}}
        <button
          class="o--btn--lg tSU--card__inputButton"
          tabindex="-1"
          type="button"
          {{on "click" this.togglePasswordVisibility}}
        >
          {{svg-jar "hide" class="o--icon--md tSU--card__inputIcon"}}
        </button>
      {{/if}}
    </div>
  
    {{#if this.showPasswordHelpText}}
      <p class="o--form__helpText u--text--sm u--text--light">
        {{t "authorization.create_account.password_requirements"}}
      </p>
    {{/if}}
  </div>
  */
  {
    "id": "rwBtOTcz",
    "block": "[[[10,0],[14,0,\"o--formWrapper--lg u--relative\"],[12],[1,\"\\n  \"],[10,\"label\"],[15,\"for\",[30,1]],[12],[1,[30,0,[\"passwordLabel\"]]],[13],[1,\"\\n  \"],[10,0],[14,0,\"u--relative\"],[12],[1,\"\\n    \"],[8,[39,0],[[24,\"autocomplete\",\"new-password\"],[16,0,[28,[37,1],[\"tSU--card__input form-control o--form__input dd-privacy-mask-user-input qa--\",[30,2]],null]],[16,\"data-test-id\",[30,3]],[16,1,[30,1]],[16,\"placeholder\",[28,[37,2],[\"authorization.create_account.placeholder_password\"],null]]],[[\"@type\",\"@value\"],[[30,0,[\"passwordInputType\"]],[30,4]]],null],[1,\"\\n\\n\"],[41,[30,0,[\"showPasswordInput\"]],[[[1,\"      \"],[11,\"button\"],[24,0,\"o--btn--lg tSU--card__inputButton\"],[24,\"tabindex\",\"-1\"],[24,4,\"button\"],[4,[38,4],[\"click\",[30,0,[\"togglePasswordVisibility\"]]],null],[12],[1,\"\\n        \"],[1,[28,[35,5],[\"view\"],[[\"class\"],[\"o--icon--md tSU--card__inputIcon\"]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[1,\"      \"],[11,\"button\"],[24,0,\"o--btn--lg tSU--card__inputButton\"],[24,\"tabindex\",\"-1\"],[24,4,\"button\"],[4,[38,4],[\"click\",[30,0,[\"togglePasswordVisibility\"]]],null],[12],[1,\"\\n        \"],[1,[28,[35,5],[\"hide\"],[[\"class\"],[\"o--icon--md tSU--card__inputIcon\"]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]]],[1,\"  \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"showPasswordHelpText\"]],[[[1,\"    \"],[10,2],[14,0,\"o--form__helpText u--text--sm u--text--light\"],[12],[1,\"\\n      \"],[1,[28,[35,2],[\"authorization.create_account.password_requirements\"],null]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[13]],[\"@id\",\"@qaClassName\",\"@dataTestID\",\"@password\"],false,[\"input\",\"concat\",\"t\",\"if\",\"on\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/credentials/password-input.hbs",
    "isStrictMode": false
  });
  let PasswordInputComponent = _exports.default = (_class = class PasswordInputComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "intl", _descriptor, this);
      _initializerDefineProperty(this, "showPasswordInput", _descriptor2, this);
    }
    get passwordInputType() {
      return this.showPasswordInput ? 'text' : 'password';
    }
    get passwordLabel() {
      return this.args.label || this.intl.t('shared_words.password');
    }
    get showPasswordHelpText() {
      return this.args.id === 'password';
    }
    togglePasswordVisibility() {
      this.showPasswordInput = !this.showPasswordInput;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "showPasswordInput", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "togglePasswordVisibility", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "togglePasswordVisibility"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, PasswordInputComponent);
});